import _ from 'lodash';
import {
    FETCH_AI_MAILER_QUESTIONS,
    CLEAN_AI_MAILER_QUESTIONS,
    DELETE_AI_MAILER_QUESTION,
    DELETE_AI_MAILER_QUESTIONS,
    EDIT_AI_MAILER_QUESTION,
} from './types';
import { request, __ } from '../functions';

export const fetchAiMailerQuestions = (screen, message_id, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request(`/ai-mailer-questions/index/${message_id}`, params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_AI_MAILER_QUESTIONS, payload: data });
    });
};

export const editAiMailerQuestion = (screen, id, language, input, output) => {
    return dispatch => request(`/ai-mailer-questions/edit/${id}`, { language, input, output }, 'POST').then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa upraviť otázku'));
            return;
        }

        screen.showSnackbar('success', __('Otázka bola upravená'));

        dispatch({ type: EDIT_AI_MAILER_QUESTION, payload: { id, language, input, output } });
    });
};

export const deleteAiMailerQuestion = (screen, id) => {
    return dispatch => request(`/ai-mailer-questions/delete/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmazať otázku'));
            return;
        }

        screen.showSnackbar('success', __('Otázka bola zmazaná'));

        dispatch({ type: DELETE_AI_MAILER_QUESTION });
    });
};

export const deleteAiMailerQuestions = (screen, ids, filtered = {}) => {
    let params = {};

    // Nasetujeme filter
    _.forEach(filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request(`/ai-mailer-questions/multiDelete/${ids}`, params).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmazať otázky'));
            return;
        }

        screen.showSnackbar('success', __('Otázky boli zmazané'));

        dispatch({ type: DELETE_AI_MAILER_QUESTIONS });
    });
};

export const cleanAiMailerQuestions = () => ({ type: CLEAN_AI_MAILER_QUESTIONS });
